import { CategoryType } from "@habity/types";
import { BRAND_COLOR } from "./brand";

type CategoriesProps = {
  label: string;
  values: CategoryType[];
  color_hex: string;
};

export const CATEGORIES: CategoriesProps[] = [
  {
    label: "Villa",
    values: ["house"],
    color_hex: BRAND_COLOR[500],
  },
  {
    label: "Lägenhet",
    values: ["apartment"],
    color_hex: BRAND_COLOR[400],
  },
  {
    label: "Par/Rad/Kedjehus",
    values: ["townhouse", "twinhouse", "terraced"],
    color_hex: BRAND_COLOR[300],
  },
  {
    label: "Gård",
    values: ["farm"],
    color_hex: BRAND_COLOR[600],
  },
  {
    label: "Fritidshus",
    values: ["cottage"],
    color_hex: BRAND_COLOR[700],
  },
  {
    label: "Kommersiellt",
    values: ["commercial"],
    color_hex: BRAND_COLOR[600],
  },
  {
    label: "Nyproduktion",
    values: ["new_construction"],
    color_hex: BRAND_COLOR[800],
  },
  {
    label: "Tomt/Övrigt",
    values: ["plot", "other"],
    color_hex: BRAND_COLOR[900],
  },
];

export const CATEGORIES_SELLER_ONBOARDING: CategoryType[] = [
  "house",
  "apartment",
  "townhouse",
  "twinhouse",
  "terraced",
  "farm",
  "cottage",
  "plot",
  "new_construction",
];
